var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdmcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2411.13 743.26",
    style: {
      enableBackground: "new 0 0 2411.13 743.26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0B5ED8;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FB3526;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2247.65,0l66.39,174.67c0,0-80.5,28-191.84,134.34c-58.36,55.79-85.9,130.15-74.62,189.18 c10.24,53.87,62.15,88.9,117.09,91.09c102.85,4.27,162.21-35.51,162.21-35.51l84.25,120.41c0,0-68.58,48.34-170.62,61.92 c-102.11,13.64-199.05,14-286.35-59.32c-87.3-73.34-128.02-161.84-73.42-309.03c54.68-147.15,194.39-258,255.09-300.37 C2196.6,24.98,2247.65,0,2247.65,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M535.55,172.82l-33.69,135.6H365.95c-52.63,1.4-71.84,5.38-76.56,23.57c0,0-10.94,21.59,31.43,46 c42.35,24.32,163.16,87.19,143.41,195.22c-18.66,101.86-113.4,172.03-257.85,170.01H0l37.27-130.21h166.21 c0,0,64.27,2.59,76.46-40.77c3.89-13.85-0.76-40.96-57.3-66.75c-48.46-22.09-124-76.2-111.6-172.22 c6.38-49.02,28.56-164.58,263.04-160.45L535.55,172.82L535.55,172.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.42,172.82l-36.24,135.6h197.07c0,0,138.23-1.11,128.82,122.64c0,0-12.47,173.41-226.16,174.58 l50.8-214.02h-172.8l-93,351.6H644c277.2,0.96,426.06-161.03,444.48-314.37c0,0,33.33-232.67-208.21-255.73L617.42,172.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1192.34,172.82h535.61c0,0,133.51,1.25,128.01,130.88l-110.47,439.52H1570l92.16-370.61 c0,0,22.74-64.56-47.64-64.19l-280.26,0.38l-113.34,434.42h-176.19L1192.34,172.82z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1313.07,743.21 1408.11,389.86 1567.66,389.86 1477.5,743.21  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdmcLogo);
export default __webpack_public_path__ + "static/media/SDMC_logo.ca55eb45810b9914f4e8232d46eae0ba.svg";
export { ForwardRef as ReactComponent };